import axios from "axios";

export default {
  getProfile(context) {
    axios.get("profile").then((res) => {
      context.commit("setProfile", res.data.data);
    });
  },
};
